import type {
  Flow_AbstractComponent,
  Flow_Diff,
  Flow_ComponentProps,
  Flow_ObjMap,
} from 'src/types/flow-to-typescript-codemod';
import type {InputAndOptionsClassNames} from 'src/components/lib/token-list-input/new-stuff';

import * as React from 'react';

import logger from 'src/utils/logger';
import classify from 'src/utils/classify';

import {Select} from 'src/components/lib/token-list-input';

import css from './select.css';


export type SelectOption<T> = {
  label: string;
  value: T;
};

export type SelectOptions<T> = SelectOption<T>[];

type SelectProps<T> = {
  options: SelectOptions<T>;
  value: SelectOption<T> | string | number | null;
  fluxRef?: any;
  className?: string;
  classNames?: InputAndOptionsClassNames;
  optionClassName?: string;
  onChange?: (value?: SelectOption<T> | null | undefined) => unknown;
  clearable?: boolean;
  searchable?: boolean;
  disabled?: boolean;
  placeholder?: string;
  name?: string;
  instanceId?: string;
  error?: unknown;
  errorText?: string;
  optionsDirection?: 'up' | 'down';
};

/**
 * DEPRECATED
 *
 * this is a legacy component that delegates to `lib/token-list-input:Select`.
 * please use that instead.
 */
export default class SoSelect<
  T extends string | number | boolean,
> extends React.Component<
  SelectProps<T> &
    Omit<
      Omit<
        Flow_ComponentProps<typeof Select>,
        'ref' | 'onChange' | 'clearable' | 'value' | 'inputProps' | 'classNames'
      >,
      keyof SelectProps<T>
    >
> {
  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<SelectProps<T> & Omit<Omit<{ value: unknown; onChange: (arg1?: unknown) => unknown; name?: string | undefined; clearable?: boolean | undefined; disabled?: boolean | undefined; autofocus?: boolean | undefined; ... 9 more ...; components?: SuggestionsComponents<...> | undefined; } & SenseTypeaheadProps<...> ...'.
  render(): React.ReactNode {
    const {
      value,
      className,
      optionClassName,
      classNames = {},
      fluxRef,
      onChange: unusedOnChange,
      instanceId,
      ...props
    } = this.props;

    const clearable = props.clearable === undefined || props.clearable;
    // @ts-expect-error - TS2749 - 'Option' refers to a value, but is being used as a type here. Did you mean 'typeof Option'?
    const optionValue: Option = ['string', 'number', 'boolean'].includes(
      typeof value,
    )
      ? props.options.find((option) => option.value === value) ?? {
          value,
          label: value,
        }
      : value;
    return (
      <Select
        ref={fluxRef}
        // @ts-expect-error - TS2322 - Type '(value?: SelectOption<T> | null | undefined) => void' is not assignable to type '(arg1?: unknown) => unknown'.
        onChange={this.handleOnChange}
        clearable={clearable}
        value={optionValue}
        inputProps={{id: instanceId}}
        classNames={{
          ...classNames,
          container: classify(className, classNames.container, css.container),
          option: classify(optionClassName, classNames.option),
        }}
        {...props}
      />
    );
  }

  handleOnChange: (value?: SelectOption<T> | null | undefined) => void = (
    value?: SelectOption<T> | null,
  ) => {
    // many nonclearable onchange handlers are not designed to handle null values
    if (this.props.clearable === false && value == null) {
      if (this.props.onChange) {
        try {
          this.props.onChange(value);
        } catch (e: any) {
          if (e instanceof TypeError) {
            logger.warn(
              'onChange in SOSelect called with null value, but it threw',
              e,
            );
          }
        }
      }
    } else if (this.props.onChange) {
      this.props.onChange(value);
    }
  };
}
